import React from "react";
import "style/Contact.scss";

import legacy from "config/i18n/legacy";
import ui from "config/i18n/ui";
import useLang from "hooks/useLang";
import usePageTitle from "hooks/usePageTitle";

import Reveal from "components/Reveal";

const Imprint = () => {
  const lang = useLang();
  const language = legacy[lang];
  // Legal text exists in English and German only; other languages show the
  // English text with a short note in their own language.
  const note = ui[lang].imprintNote;
  const heading =
    lang === "en" || lang === "de"
      ? language.imprint.header
      : language.footer.imprint;
  usePageTitle(language.footer.imprint);

  return (
    <div className="page">
      <header className="page__hero">
        <div className="shell">
          <h1>{heading}</h1>
        </div>
      </header>

      <main className="shell page__body">
        <Reveal className="page__card">
          {note && lang !== "en" && lang !== "de" ? (
            <p className="contact-info__note">{note}</p>
          ) : null}
          <div className="prose" lang={lang === "de" ? "de" : "en"}>
            {language.imprint.article.map((article, index) => (
              <article key={index}>
                <h2>{article.header}</h2>
                <p>{article.content1}</p>
                {"content2" in article && article.content2 ? (
                  <p>{article.content2}</p>
                ) : null}
              </article>
            ))}
          </div>
        </Reveal>
      </main>
    </div>
  );
};

export default Imprint;
